import { ApolloClient, InMemoryCache } from "@apollo/client";
const client = new ApolloClient({
  uri: "https://shopbackend00.herokuapp.com",
  cache: new InMemoryCache(),
});
export default client;
